import { createSlice } from "@reduxjs/toolkit";
import { topCausesAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const topCausesSlice = createSlice({
  name: "topCauses",
  initialState: data,
  reducers: {
    topCausesSlice(state) {
      state.isLoading = true;
    },
    topCausesSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    topCausesSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    topCausesSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const topCausesHandler = () => async (dispatch: any) => {
  try {
    dispatch(topCausesAction.topCausesSlice());
    const response: any = await topCausesAPI();
    dispatch(topCausesAction.topCausesSliceSuccess(response));
  } catch (e: any) {
    dispatch(topCausesAction.topCausesSliceFailure(e?.response?.data?.message));
    dispatch(topCausesAction.topCausesSliceReset());
  }
};
export default topCausesSlice.reducer;
export const topCausesAction = topCausesSlice.actions;
